(ns practitest.frontend.active-sessions.views
  (:require
   [re-frame.core :as re-frame]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.common.re-frame :refer [partial-dispatch]]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.components2.grid :as grid2]
   [practitest.frontend.active-sessions.subs :as active-sessions-subs]
   [practitest.frontend.active-sessions.events :as active-sessions-events]
   [practitest.frontend.common-entities.events :as common-events]
   [practitest.frontend.components.grid.subs :as grid.subs]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
   [practitest.frontend.subs :as subs]
   [reagent.core :as reagent]))

(def current-entity :active-sessions)
(def state-key :active-sessions-index)

(def columns
  [{:autofilter? true
    :default-width 200
    :field :user_name
    :header "User Name"
    :type :text}
   {:autofilter? true
    :default-width 250
    :field :email
    :header "Email"
    :type :text}
   {:default-width 200
    :field :last_active_time
    :header "Last Active Time"
    :type :date-time}
   {:autofilter? true
    :default-width 150
    :field :project
    :header "Project"
    :type :text}])

(def post-columns
  [{:header        ""
    :field         :actions
    :default-width 120
    :width         120
    :type          :custom
    :text-align    :center
    :resizable?    false
    :sortable?     false
    :systemcol?    true
    :cell-fn       (fn [_ row]
                     (let [current-user @(re-frame/subscribe [::subs/current-user])]
                       (when (not= (:user_id row) (:id current-user))
                         [buttons/button
                          {:text (get-translation "active-session.button.terminate" "Terminate")
                           :danger? true
                           :size :small
                           :on-click (fn []
                                       (when (js/confirm (str "Are you sure you want to terminate the session for " (:user_name row) "?"))
                                         (re-frame/dispatch [::active-sessions-events/terminate-session (:user_id row)])))}])))}])

(defn toolbar []
  (let [total @(re-frame/subscribe [::active-sessions-subs/total-licenses])
        used @(re-frame/subscribe [::active-sessions-subs/used-licenses])]
    [:div.active-sessions-toolbar
     [:div.licenses-info
      (str used " " (get-translation "active-sessions.info.out-of" "out of") " " total)
      " "
      (get-translation "active-sessions.info.licenses-in-use" "Tester Licenses are currently in use")]]))

(defn active-sessions-grid [grid-state]
  (let [table-id "active-sessions-index"
        sessions @(re-frame/subscribe [::active-sessions-subs/get-all-sessions])
        grid-props {:columns columns
                    :post-columns post-columns
                    :table-id table-id
                    :grid-state grid-state
                    :local-state-updating grid-state
                    :full-data? true
                    :expanded? @(re-frame/subscribe [::grid.subs/expanded? current-entity state-key])
                    :on-expand-click (partial-dispatch [::common-events/toggle-expanded current-entity state-key])
                    :current-page-load     (reagent/partial grid-storage/load-current-page table-id)
                    :current-page-save     (reagent/partial grid-storage/save-current-page table-id)
                    :per-page-save         (reagent/partial grid-storage/save-per-page table-id)
                    :per-page-load         (reagent/partial grid-storage/load-per-page table-id)
                    :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id)
                    :sort-order-load       (reagent/partial grid-session-storage/load-sort-order table-id)
                    :data sessions
                    :grid-toolbar toolbar
                    :class "admin-page-table"}]
    [:div.active-sessions-grid
     [grid2/grid grid-props]]))

(defn main-panel []
  (let [grid-state (reagent/atom {:module "active-sessions"})]
    [:div.active-sessions-page
     [active-sessions-grid grid-state]]))
